import contentSlice from './content/slice.ts';
import contextSlice from './context/slice.ts';
import databasesSlice from './databases/slice.ts';
import datasourcesSlice from './datasources/slice.ts';
import jiraSlice from './jira/slice.ts';
import spacesSlice from './spaces/slice.ts';
import usersSlice from './users/slice.ts';

export const commonReducers = {
  content: contentSlice.reducer,
  context: contextSlice.reducer,
  databases: databasesSlice.reducer,
  jira: jiraSlice.reducer,
  spaces: spacesSlice.reducer,
  users: usersSlice.reducer,
  datasources: datasourcesSlice.reducer
};
